/* This bridge only guards missing mounts and navigates to controls.
   Persoly's versioned runtime retains all validation, capture and cart authority. */
(() => {
  'use strict';
  if (window.PersolyThemeV6) return;
  const selector = '[data-persoly-runtime-required]';
  const mounted = new Map();
  function attach(section) {
    let pending = false;
    const ready = () => {
      const roots = section.querySelectorAll('[data-persoly-pixel-root]');
      return !!window.PersolyPixelPreview && roots.length === 1 &&
        roots[0].classList.contains('persoly-preview') &&
        !!roots[0].querySelector('.persoly-preview__status') &&
        !section.querySelector('[data-gbapz-root], [data-persoly-preview-root], [data-persoly-file-preview-root]');
    };
    const notice = () => section.querySelector('[data-persoly-runtime-notice]');
    const controls = () => section.querySelector('[data-persoly-pixel-root]');
    const jump = section.querySelector('[data-persoly-jump]');
    const jumpButton = jump?.querySelector('button');
    const update = () => {
      pending = false;
      const active = ready();
      section.dataset.persolyRuntimePresent = String(active);
      const message = notice();
      if (message) message.hidden = active;
      // Only release our server-rendered boot lock. Never lift inventory or
      // app locks, and never infer can_add_to_cart from a successful preview.
      if (active) for (const button of section.querySelectorAll('[data-persoly-boot-lock]')) {
        button.removeAttribute('data-persoly-boot-lock');
        button.disabled = false;
      }
      if (jump) jump.hidden = !active;
    };
    const schedule = () => {
      if (pending) return;
      pending = true;
      queueMicrotask(update);
    };
    const stopUnboundSubmit = event => {
      if (!(event.target instanceof HTMLFormElement) ||
          !event.target.matches('product-form form') || ready()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const message = notice();
      if (message) { message.hidden = false; message.focus(); }
    };
    const go = () => {
      const target = controls();
      if (!target) return;
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const focusable = target.querySelector('input:not([type=hidden]), select, button');
      focusable?.focus({ preventScroll: true });
    };
    section.addEventListener('submit', stopUnboundSubmit, true);
    jumpButton?.addEventListener('click', go);
    const observer = new MutationObserver(schedule);
    observer.observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-persoly-boot-lock'] });
    update();
    return () => { observer.disconnect(); section.removeEventListener('submit', stopUnboundSubmit, true); jumpButton?.removeEventListener('click', go); };
  }
  function mount() {
    for (const [section, destroy] of mounted) if (!section.isConnected) { destroy(); mounted.delete(section); }
    for (const section of document.querySelectorAll(selector)) if (!mounted.has(section)) mounted.set(section, attach(section));
  }
  window.PersolyThemeV6 = { mount };
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, destroy] of mounted) if (event.target.contains(section)) { destroy(); mounted.delete(section); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
})();
